import { UID } from 'shared/api/query/constants';
import { storageObject as storageObjectConfig } from 'shared/api/query/configs.json';

export const storageObjectEdges = [
  { attr: UID },
  { attr: storageObjectConfig.edges.getURL },
  { attr: storageObjectConfig.edges.updateURL },
  { attr: storageObjectConfig.edges.fileName },
  { attr: storageObjectConfig.edges.blob },
];
